export default __webpack_public_path__ + "static/media/Vashian Schenti.e62968da.jpg";